export default {
  GET_PRE_SALES_PROJECTS: "Get pre sales projects",

  // error messages
  GET_PRE_SALES_PROJECTS_ERROR: "Error while getting pre sales projects",
};
